export const ACTIVITY_TYPES = 'activity types';
export const MOBILE_FEATURES = 'mobile features';
